module.exports = __webpack_public_path__ + "img/br.92fc615.svg";